import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { reportAegisError } from '@/utils/aegis';
import { loadScript } from '@/utils/utils';

const app = createApp(App).use(store).use(router);
app.config.errorHandler = (err: any) => {
  if (!err.toString().includes('弹窗拦截')) {
    reportAegisError({
      type: 'UNHANDLED_ERROR',
      error: err?.stack || err.toString(),
    });
  }
};
app.use(ElementPlus, {
  locale: zhCn,
});
app.mount('#app');
// app.config.globalProperties.$http = fly;

if (origin.includes('tengmed.com') || origin.includes('localhost')) {
  loadScript('https://turing.captcha.qcloud.com/TCaptcha.js');
}
